import { addParams, combineURLs } from '../../helper';
const combineParams = function (ctx, next) {
    let { url } = ctx;
    const { req } = ctx;
    if (req.baseUrl) {
        url = combineURLs(req.baseUrl, url);
    }
    url = addParams(url, req.params);
    req.url = url;
    ctx.url = url;
    return next();
};
export default combineParams;
//# sourceMappingURL=combineParams.js.map